import React, { PureComponent } from 'react'
import { DsButton, DsButtonProps } from '@am92/react-design-system'

export interface IButtonErrorProps
  extends Omit<DsButtonProps, 'variant' | 'color'> {}

export default class ButtonError extends PureComponent<IButtonErrorProps> {
  render() {
    const { ref, ...restProps } = this.props
    const { disabled } = restProps

    return (
      <DsButton
        {...restProps}
        color='error'
        sx={{
          border: '1px solid',
          borderColor: disabled
            ? 'var(--ds-colour-strokeDisabled)'
            : 'var(--ds-colour-supportNegative)',
          borderRadius: '44px',
          backgroundColor: disabled
            ? 'transparent !important'
            : 'var(--ds-colour-supportNegativeNeutral)',
          color: disabled
            ? 'var(--ds-colour-typoDisabled) !important'
            : 'var(--ds-colour-typoOnSurface) !important',
          py:
            restProps.size === 'small'
              ? 'var(--ds-spacing-glacial)'
              : 'var(--ds-spacing-bitterCold)',
          px:
            restProps.size === 'small'
              ? 'var(--ds-spacing-bitterCold)'
              : 'var(--ds-spacing-warm)',
          fontSize: 'var(--ds-typo-fontSizeBitterCold)',
          fontWeight: 'var(--ds-typo-fontWeightRegular)',
          lineHeight: 'var(--ds-typo-fontSizeCool)',
          ':hover': {
            backgroundColor: 'var(--ds-colour-supportNegativeNeutral)'
          },
          ...restProps.sx
        }}
      />
    )
  }
}
